/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import axios from 'axios';

export function addHeader(key, value) {
  axios.defaults.headers.common[key] = value;
}

export function removeHeader(key) {
  delete axios.defaults.headers.common[key];
}

export function setBackendUrl(url) {
  axios.defaults.baseURL = url;
}

export const axiosClient = axios;
